export const presetStates = {
  default: {
    image: '/icons/colored/empty_box.svg',
  },
  locked: {
    image: '/icons/colored/content_locked.svg',
  },
}
